// ----------------------------------------------------------------------
// <copyright file="DateFormatter.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Date formatter utility
 */
var Izenda = (function () {
  'use strict';

  /**
   * Constructor
   */
  function DateFormatter() {
  }

  /**
 * Formats the given date by the given pattern in UTC without timezone specific information.<br />
 * Following switches are supported:
 * <ul>
 * <li>yyyy: The year</li>
 * <li>MM: the month</li>
 * <li>dd: the day of month<li>
 * <li>hh: the hour<li>
 * <li>mm: minutes</li>
 * </ul>
 * @param {Date} dateValue the date to format
 * @param {String} formatPattern the format pattern
 * @return {String} formatted date string
 * @static
 */
  DateFormatter.prototype.formatUTCDate = function (dateValue, formatPattern) {
    var day = formatNumber(dateValue.getDate(), 2);
    var month = formatNumber(dateValue.getMonth() + 1, 2);
    var yearLong = formatNumber(dateValue.getFullYear(), 4);
    var yearShort = formatNumber(dateValue.getFullYear().toString().substring(3, 4), 2);
    var year = (formatPattern.indexOf("yyyy") > -1 ? yearLong : yearShort);
    var hour = formatNumber(dateValue.getHours(), 2);
    var minute = formatNumber(dateValue.getMinutes(), 2);
    var second = formatNumber(dateValue.getSeconds(), 2);
    var dateString = formatPattern.replace(/dd/g, day).replace(/MM/g, month).replace(/y{1,4}/g, year);
    dateString = dateString.replace(/hh/g, hour).replace(/mm/g, minute).replace(/ss/g, second);
    return dateString;
  };

  /**
   * Add prefix zero (0) to string
   * @param {string} source
   * @param {number} length
   * @returns {string}
   */
  function addZero(source, length) {
    while (source.length < length) {
      source = "0" + source;
    }
    return source;
  }

  /**
   * Format number
   * @param {number} number
   * @param {number} numberOfvarters
   * @returns {string}
   */
  function formatNumber(number, numberOfLetters) {
    var dataString = number.toString();
    return addZero(dataString, numberOfLetters);
  }

  return { DateFormatter: DateFormatter };
}());

module.exports = { DateFormatter: Izenda.DateFormatter };



// WEBPACK FOOTER //
// ./ui/share/logging/common/DateFormatter.js